/**
 * CRA inlines REACT_APP_* at build time, but some hosts omit them from webpack.
 * Prefer `embeddedGoogleOAuthClientId` from googleClientId.embedded.js (emit by scripts/embed-env.cjs).
 */

import { embeddedGoogleOAuthClientId } from './googleClientId.embedded';

const PUBLIC_GOOGLE_OAUTH_CLIENT_ID =
  '234989788683-tshc2ttniuhbp22kk16bmtofmkn50u44.apps.googleusercontent.com';
const PLACEHOLDER_SUBSTRINGS = ['placeholder', 'your-client-id', 'xxx.apps.googleusercontent'];

export function resolveGoogleOAuthClientId() {
  const embedded = typeof embeddedGoogleOAuthClientId === 'string' ? embeddedGoogleOAuthClientId.trim() : '';
  const v = embedded || String(process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim() || PUBLIC_GOOGLE_OAUTH_CLIENT_ID;
  if (!v) {
    return '';
  }
  const lower = v.toLowerCase();
  if (PLACEHOLDER_SUBSTRINGS.some((p) => lower.includes(p))) {
    return '';
  }
  return v;
}

/** Enables "Continue with Google" when client id looks like a real OAuth web client. */
export function isGoogleLoginConfigured() {
  const id = resolveGoogleOAuthClientId();
  if (!id) {
    return false;
  }
  const lower = id.toLowerCase();
  // Web OAuth client IDs normally end with this suffix; allow slight format drift from Google.
  if (lower.endsWith('.apps.googleusercontent.com') && id.length >= 20) {
    return true;
  }
  return /^\d+-[a-z0-9_.-]+\.apps\.googleusercontent\.com$/i.test(id);
}
